import { StrategicAxesRepository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: StrategicAxesRepository): Interactor {
  return ({ planzone, strategicAxis, nextStrategicAxis }) =>
    present(
      repository
        .editStrategicAxis(planzone, strategicAxis, nextStrategicAxis)
        .then((updatedStrategicAxis) => ({
          planzone,
          strategicAxis: updatedStrategicAxis,
        }))
        .catch(() => Promise.reject({ planzone, strategicAxis })),
    );
}

export type { Interactor };

export { createInteractor };
